import React, { useState } from "react";

const Faq = ({ data }: any) => {
  function getSortedSectionsWRpage(data: any, section: any, page: any) {
    return data
      .filter((item: any) => item.Section === section && item.Page === page)
      .sort((a: any, b: any) => a.Sequence - b.Sequence)
      .map((item: any) => ({
        id: item.id,
        section: item.Section,
        page: item.Page,
        type: item.Type,
        Title: item.Title,
        URL: item.URL,
        Content: item.content,
        Image_Path: item.Image_Path,
        sequence: item.sequence,
      }));
  }
  const [videoLoaded, setVideoLoaded] = useState(false);
  const aboutUsData = getSortedSectionsWRpage(data, "FAQ", "FAQ");
  const ruleData = getSortedSectionsWRpage(data, "FAQ", "FAQ");
  const bulletPoints = ruleData[0]?.Content?.split("•").filter(
    (point: any) => point.trim() !== "",
  );

  const journeyData = getSortedSectionsWRpage(
    data,
    "Our Journey of Viva",
    "About us",
  );
  const founderData = getSortedSectionsWRpage(data, "Our Founders", "About us");
  const organizingTeamData = getSortedSectionsWRpage(
    data,
    "Core Organising Team",
    "About us",
  );

  // useEffect(() => {
  //   const iframe = document.getElementById("youtubeIframe");
  //   if (iframe) {
  //     iframe.onload = () => setVideoLoaded(true);
  //   }
  // }, []);
  return (
    <>
      {/* <div
        style={{
          display: "flex",
          backgroundColor: "var(--S4-Primary, #E1E8F5)",
          margin: "20px",
          borderRadius: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "20px",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              color: "#000",
              // textAlign: "center",
              fontFamily: "Graphik,sans-serif",
              fontSize: "48px",
            }}
          >
            {aboutUsData[0]?.Title}
          </div>
          <div
            style={{
              color: "#000",
              // textAlign: "center",
              fontFamily: "Graphik,sans-serif",
              fontSize: "24px",
            }}
          >
            {aboutUsData[0]?.Content}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              overflow: "hidden",
              paddingTop: "3rem",
              paddingBottom: "3rem",
            }}
          >
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/je3SkN7fcHw?si=G7iAgBIYeejMidXV"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
          <div
            style={{
              color: "#000",
              // textAlign: "center",
              fontFamily: "Graphik,sans-serif",
              fontSize: "24px",
              overflow: "hidden",
            }}
          >
            {aboutUsData[2]?.Content}
          </div>
        </div>
      </div> */}
      <div
        style={{
          display: "flex",
          backgroundColor: "rgba(232, 173, 190, 0.1)",
          margin: "20px",
          // opacity: "0.1",
          borderRadius: "20px",
          marginTop: "40px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "20px",
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: bulletPoints }} />
          {/* 
          <div
            style={{
              color: "var(--Text, #212121)",
              // textAlign: "center",
              fontFamily: "Graphik,sans-serif",
              fontSize: "34px",
              paddingBottom: "1rem",
            }}
          >
            {ruleData[0]?.Title}
          </div>
          <div
            style={{
              color: "var(--Text-2, #666)",
              fontSize: "1.5rem",
            }}
          >
            {bulletPoints?.map((point: any, index: any) => (
              <div key={index} style={{ marginBottom: "10px" }}>
                • {point}
              </div>
            ))}
          </div> */}
        </div>
      </div>
      {/* <div style={{ marginTop: "2.5rem", backgroundColor: "#F5F5FF" }}>
        <div
          style={{
            // height: "53px",
            color: "var(--Text, #212121)",
            textAlign: "center",
            fontFamily: "Graphik,sans-serif",
            textTransform: "capitalize",
            fontSize: "48px",
            padding: "20px",
          }}
        >
          {journeyData[0]?.Title}
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "150px",
            fontFamily: "Graphik,sans-serif",
            alignItems: "center",
            justifyContent: "center",
            paddingTop: "50px",
            paddingBottom: "30px",
          }}
        >
          {journeyData.map((item: any, index: any) => {
            const contentParts = item.Content.split(" ");
            return (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{
                    fontSize: "34px",
                    textAlign: "center",
                    color: "var(--Text, #212121)",
                  }}
                >
                  {contentParts[0]}
                </div>
                <div
                  style={{
                    fontSize: "24px",
                    textAlign: "center",
                    color: "var(--Text-2, #666)",
                  }}
                >
                  {contentParts.slice(1).join(" ")}
                </div>
              </div>
            );
          })}
        </div>
      </div> */}
      {/* <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: "40px",
          // backgroundColor: "blue",
        }}
      >
        <div
          style={{
            // height: "53px",
            color: "var(--Text, #212121)",
            textAlign: "center",
            fontFamily: "Graphik,sans-serif",
            textTransform: "capitalize",
            fontSize: "48px",
            padding: "20px",
          }}
        >
          {founderData[0]?.section}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyItems: "center",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "0.625rem",
            gap: "2rem",
          }}
        >
          {founderData.map((founder: any, index: any) => (
            <CARD
              key={index}
              Image_Path={founder.Image_Path}
              Title={founder.Title}
              Content={founder.Content}
            />
          ))}
        </div>
      </div> */}
      {/* <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: "40px",
          // backgroundColor: "blue",
        }}
      >
        <div
          style={{
            // height: "53px",
            color: "var(--Text, #212121)",
            textAlign: "center",
            fontFamily: "Graphik,sans-serif",
            textTransform: "capitalize",
            fontSize: "48px",
            padding: "20px",
          }}
        >
          {organizingTeamData[0]?.section}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyItems: "center",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "0.625rem",
            gap: "2rem",
          }}
        >
          {organizingTeamData.map((founder: any, index: any) => (
            <CARD
              key={index}
              Image_Path={founder.Image_Path}
              Title={founder.Title}
              Content={founder.Content}
            />
          ))}
        </div>
      </div> */}
    </>
  );
};

export default Faq;
